import { put, call, takeEvery } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { Slide } from '../types'
import { FETCH_SLIDES, FETCH_SLIDES_FAIL, FETCH_SLIDES_SUCCESS, FetchSlidesAction } from '../redux/manageSlidesReducer'

function* FetchSlidesFlow(action: FetchSlidesAction): Generator<any, void, any> {
  try {
    const response: Slide[] = yield call(apiCall, {
      endpoint: `/tutors/lesson_plans/${action.payload.lessonPlanId}/slides`,
      method: 'GET',
      params: {}
    })
    yield put(FETCH_SLIDES_SUCCESS({ lessonPlanId: action.payload.lessonPlanId, slides: response }))
  } catch (error) {
    yield put(FETCH_SLIDES_FAIL())
    console.log(error)
  }
}

export default function* FetchSlidesSaga(): Generator<any, void, any> {
  yield takeEvery([FETCH_SLIDES], FetchSlidesFlow)
}
